import React from "react";
import { Box, IconButton } from "@mui/material";
import { PlayArrow, Fullscreen } from "@mui/icons-material";

const VideoEmbed = ({
  videoId,
  url,
  platform = "youtube", // 🆕 NUEVO: Soporte para 'youtube' o 'vimeo'
  title = "Video",
  width = "100%",
  height = 400,
  autoplay = false,
  showControls = true,
}) => {
  // 🆕 NUEVO: Función para detectar automáticamente la plataforma desde URL
  const detectPlatform = (videoUrl) => {
    if (!videoUrl) return "youtube";

    if (videoUrl.includes("vimeo.com")) return "vimeo";
    if (videoUrl.includes("youtube.com") || videoUrl.includes("youtu.be"))
      return "youtube";

    return "youtube"; // Default
  };

  // 🆕 NUEVO: Extraer ID de video de YouTube
  const extractYouTubeId = (url) => {
    if (!url) return null;

    // Si ya es solo el ID
    if (url.length === 11 && !url.includes("/")) return url;

    // Diferentes formatos de YouTube URLs
    const patterns = [
      /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/,
      /(?:youtube\.com\/embed\/)([^"&?\/\s]{11})/,
      /(?:youtube\.com\/watch\?v=)([^"&?\/\s]{11})/,
    ];

    for (const pattern of patterns) {
      const match = url.match(pattern);
      if (match) return match[1];
    }

    return null;
  };

  // 🆕 NUEVO: Extraer ID de video de Vimeo
  const extractVimeoId = (url) => {
    if (!url) return null;

    // Si ya es solo el ID numérico
    if (/^\d+$/.test(url)) return url;

    // Diferentes formatos de Vimeo URLs
    const patterns = [
      /(?:vimeo\.com\/)(\d+)/,
      /(?:vimeo\.com\/video\/)(\d+)/,
      /(?:player\.vimeo\.com\/video\/)(\d+)/,
    ];

    for (const pattern of patterns) {
      const match = url.match(pattern);
      if (match) return match[1];
    }

    return null;
  };

  // Determinar plataforma y extraer ID
  const detectedPlatform = url ? detectPlatform(url) : platform;
  let finalVideoId;

  if (detectedPlatform === "vimeo") {
    finalVideoId = extractVimeoId(url || videoId);
  } else {
    finalVideoId = extractYouTubeId(url || videoId) || videoId;
  }

  if (!finalVideoId) {
    return (
      <Box
        sx={{
          width,
          height,
          backgroundColor: "#f0f0f0",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        Video no disponible
      </Box>
    );
  }

  // 🆕 NUEVO: Generar URL de embed según la plataforma
  const getEmbedUrl = () => {
    if (detectedPlatform === "vimeo") {
      const vimeoParams = new URLSearchParams({
        autoplay: autoplay ? "1" : "0",
        controls: showControls ? "1" : "0",
        title: "0",
        byline: "0",
        portrait: "0",
        playsinline: "1",
      });
      return `https://player.vimeo.com/video/${finalVideoId}?${vimeoParams}`;
    } else {
      // YouTube
      const youtubeParams = new URLSearchParams({
        autoplay: autoplay ? "1" : "0",
        controls: showControls ? "1" : "0",
        rel: "0",
        modestbranding: "1",
        playsinline: "1",
      });
      return `https://www.youtube.com/embed/${finalVideoId}?${youtubeParams}`;
    }
  };

  const embedUrl = getEmbedUrl();

  return (
    <Box
      sx={{
        width,
        height,
        position: "relative",
        "& iframe": {
          width: "100%",
          height: "100%",
          border: "none",
          borderRadius: 1,
        },
      }}
    >
      <iframe
        src={embedUrl}
        title={title}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      />
    </Box>
  );
};

// 🆕 NUEVO: Mantener compatibilidad con el nombre anterior
export const YouTubeEmbed = VideoEmbed;
export default VideoEmbed;
